export enum BookingEventsEnum {
  BOOKING_SUBMITTED = "booking_submitted",
  BOOKING_CONFIRMED = "booking_confirmed",
  BOOKING_VALIDATED = "booking_validated",
  BOOKING_CANCELED = "booking_canceled",
  BOOKING_INCOMPLETE = "booking_incomplete",
  BOOKING_ENDED = "booking_ended",
  BOOKING_NO_SHOW = "booking_no_show",
  BOOKING_TO_BE_CONFIRMED = "booking_to_be_confirmed",
  BOOKING_DATES_UPDATED = "booking_dates_updated",
  BOOKING_NOTIFICATION = "booking_notification",
  CPF_BOOKING_TO_CONFIRM = "cpf_booking_to_confirm",
  DELAYED_PEDAGOGICAL_REPORT = "delayed_pedagogical_report",
  DIRECT_PEDAGOGICAL_REPORT = "direct_pedagogical_report",
  SEND_ICS = "send_ics",
}

export enum BookingStatusEnum {
  BOOKING_TO_BE_CONFIRMED = "to_be_confirmed",
  BOOKING_CONFIRMED = "confirmed",
  BOOKING_TRAINING_STARTED = "training_started",
  BOOKING_TRAINING_ENDED = "training_ended",
  BOOKING_ON_HOLD = "on_hold",
  BOOKING_CANCELED = "canceled",
  BOOKING_REFUSED = "refused",
  BOOKING_MISSING_PROOFS = "missing_proofs",
  BOOKING_BILLABLE = "billable",
  BOOKING_INCOMPLETE = "incomplete",
  BOOKING_NO_SHOW = "no_show",
  BOOKING_REMOVED = "removed",
}

export enum BookingICSStatusEnum {
  PENDING = "pending",
  ACCEPTED = "accepted",
  REJECTED = "rejected",
  CANCELED = "canceled",
}
